import React, { useState, useEffect } from "react"
import clsx from "clsx"

import Container from "@ecom/ui/components/Container"

import { Form } from "./Form"
import { Slider } from "./Slider"
import { GradientBg } from "../GradientBg"

import { calcMonthlyPayment, calcMonthlySavings } from "./helpers"
import { CalcWithFormContext } from "../../context"

import type { ICalcConfig } from "./types"

import * as styles from "./CalculatorWithForm.module.scss"

export type CalculatorProps = {
  title?: string
  subtitle?: string
  textWithAsterisk?: string
  orderNum?: string
  config: ICalcConfig
}

const CalculatorWithForm = ({
  title = "Рассчитайте условия рефинансирования",
  subtitle = "Укажите примерные суммы для расчета*",
  textWithAsterisk = "Расчёт является предварительным, произведен на основе данных текущих пользователей",
  orderNum,
  config,
}: CalculatorProps) => {
  const { term, loanAmountConfig, payMonthlyConfig } = config

  const [loanAmount, setLoanAmount] = useState(loanAmountConfig.initialValue)
  const [payMonthlyNow, setPayMonthlyNow] = useState(payMonthlyConfig.initialValue)
  const [willPayMonthly, setWillPayMonthly] = useState(0)
  const [monthlySavings, setMonthlySavings] = useState(0)

  useEffect(() => {
    const pay = calcMonthlyPayment(loanAmount, term)
    setWillPayMonthly(pay)
  }, [loanAmount, term])

  useEffect(() => {
    const savings = calcMonthlySavings(payMonthlyNow, willPayMonthly)
    setMonthlySavings(savings)
  }, [payMonthlyNow, willPayMonthly])

  const showSavings = monthlySavings > 0

  return (
    <CalcWithFormContext.Provider value={{ loanAmount, term }}>
      <section id="calculatorRefin" data-exclude={orderNum} className={styles.section}>
        <Container className={styles.container}>
          <GradientBg className={styles.wrapper}>
            <div className={styles.sliderContainer}>
              <div className={styles.head}>
                <h3 className={styles.title}>{title}</h3>
                {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
              </div>
              <div className={styles.sliders}>
                <Slider
                  title="Сумма текущих кредитов"
                  value={loanAmount}
                  min={loanAmountConfig.min}
                  max={loanAmountConfig.max}
                  step={loanAmountConfig.step}
                  setValue={setLoanAmount}
                  name="calc_sum_credit"
                />
                <Slider
                  title="Плачу сейчас ежемесячно"
                  value={payMonthlyNow}
                  min={payMonthlyConfig.min}
                  max={payMonthlyConfig.max}
                  step={payMonthlyConfig.step}
                  setValue={setPayMonthlyNow}
                  name="monthly_payment"
                />
              </div>
            </div>
            <div className={clsx(styles.form, { [styles.noSavingsVal]: !showSavings })}>
              <Form willPayMonthly={willPayMonthly} monthlySavings={monthlySavings} />
            </div>
            <p className={styles.asterisk}>{textWithAsterisk}</p>
          </GradientBg>
        </Container>
      </section>
    </CalcWithFormContext.Provider>
  )
}

export default CalculatorWithForm
